import styled from 'styled-components/macro';

export const Container = styled.div`
  margin: 0 20px 150px;
`;
